export default __webpack_public_path__ + "static/media/js-1.0d38a526.png";